import React, { useMemo, useCallback, useState, useEffect } from "react";
import { Button, Select } from "antd";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import { useDispatch, useSelector } from "react-redux";

import { handleUpdateShowLogin } from "store/user";
import { getListAddressApi } from "@libs/apis/address";

import { ASSETS_URL, CONVERT_RATE } from "configs/constant";
import { formatImage } from "@utils/helpers/logic/image";

import Modal from "../Modal";
import AddressPage from "@components/pages/user/Address";

import iconLeft from "@public/images/item-accessory.png";
import iconPoint from "@public/images/icon-point.svg";
import iconCoin from "@public/icons/icon-coin.svg";

const AccessoriesItem = ({
  usePoint = true,
  visible,
  onCancel,
  pointHas,
  handleChangeNow,
  data,
  hasCourseTemplate = false,
  isMembershipCard = false,
  userLevel,
  hasSelectAddress = false,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("gift");

  const isAuth = useSelector((state) => state?.authReducer?.isAuth);

  const [listAddress, setListAddress] = useState([]);
  const [addressValue, setAddressValue] = useState("");
  const [addressModalVisible, setAddressModalVisible] = useState(false);

  useEffect(() => {
    getListAddressApi()
      .then((res) => {
        const list = res?.data?.data;
        const options = list?.map((item) => ({
          key: item?.id,
          value: item?.id,
          label: [
            item?.fullName,
            item?.phone,
            [
              item?.address,
              item?.village?.name,
              item?.district?.name,
              item?.province?.name,
            ]?.join(", "),
          ]?.join("-"),
        }));
        setListAddress(options);
      })
      .catch((err) => console.log("== err", err));
  }, []);

  useEffect(() => {
    if (!addressModalVisible) {
      getListAddressApi()
        .then((res) => {
          const list = res?.data?.data;
          const options = list?.map((item) => ({
            key: item?.id,
            value: item?.id,
            label: [
              item?.fullName,
              item?.phone,
              [
                item?.address,
                item?.village?.name,
                item?.district?.name,
                item?.province?.name,
              ]?.join(", "),
            ]?.join("-"),
          }));
          setListAddress(options);
        })
        .catch((err) => console.log("== err", err));
    }
  }, [addressModalVisible]);

  const qualifiedLevel = useMemo(
    () => userLevel === data?.beRichLevel?.level,
    [userLevel, data?.beRichLevel?.level],
  );

  const TEMP_IMAGE_URL =
    "https://daotaoclbberich.s3.ap-southeast-1.amazonaws.com/fmdaotao/images";

  const tempImageUrlFormat = (link) => {
    const splitArr = link?.split("/");

    return splitArr?.at(-1);
  };

  const handleOnClickBuy = (id) => {
    if (isAuth) {
      handleChangeNow(id, addressValue);
    } else {
      dispatch(handleUpdateShowLogin(true));
    }
  };

  const renderDescription = (desc) => {
    const tempDesc = desc.replaceAll("//", "<br />");

    return `<p>${tempDesc}</p>`;
  };

  const renderText = useCallback(() => {
    if (data?.isOwned) {
      return "owned";
    } else {
      if (!qualifiedLevel) {
        return "unqualifiedLevel";
      } else {
        if (data?.quantity <= 0) {
          return "outOfStock";
        } else {
          if (pointHas < data?.price) {
            return "notEnoughPoint";
          } else {
            return "confirm";
          }
        }
      }
    }
  }, [data?.isOwned, qualifiedLevel, data?.quantity, pointHas, data?.price]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      className="modal-item"
      closable={true}
      width="780px"
    >
      {addressModalVisible && (
        <Modal
          visible={addressModalVisible}
          onCancel={() => setAddressModalVisible(false)}
          className="modal-address"
          closable={true}
          width="780px"
        >
          <AddressPage isModal={true} setVisible={setAddressModalVisible} />
        </Modal>
      )}
      <div className="accessories-item">
        <div className="accessories-item__image">
          {hasCourseTemplate ? (
            <Image
              src={
                data?.image
                  ? `${TEMP_IMAGE_URL}/${tempImageUrlFormat(data?.image)}`
                  : iconLeft
              }
              alt="image"
              layout="fill"
            />
          ) : (
            <Image
              src={
                data?.image?.length > 0
                  ? `${ASSETS_URL}/${formatImage(data?.image)}`
                  : iconLeft
              }
              alt="image"
              layout="fill"
            />
          )}
        </div>
        <div className="accessories-item__content">
          <h2>{data?.name || ""}</h2>
          <div className="price">
            <span>
              <Image
                src={usePoint ? iconPoint : iconCoin}
                alt="price"
                width={24}
                height={24}
              />
            </span>
            {hasCourseTemplate ? (
              <span className="main-price">
                {Number(data?.price) / CONVERT_RATE}
              </span>
            ) : (
              <span className="main-price">
                {usePoint
                  ? data?.point
                  : isMembershipCard
                  ? Number(data?.price || 0) / CONVERT_RATE
                  : data?.coin}
              </span>
            )}
          </div>
          <p className="title">{data?.title}</p>
          {hasCourseTemplate ? (
            <p
              className="des"
              dangerouslySetInnerHTML={{
                __html: renderDescription(data?.description || ""),
              }}
            />
          ) : (
            <p
              className="des"
              dangerouslySetInnerHTML={{
                __html: isMembershipCard
                  ? data?.content
                  : data?.information || data?.description || "",
              }}
            />
          )}
          {hasSelectAddress && (
            <div className="accessories-item__content__select">
              <p>Địa chỉ nhận hàng</p>
              <Select
                options={listAddress}
                onChange={(e) => setAddressValue(e)}
                value={addressValue}
              />
              <a onClick={() => setAddressModalVisible(true)}>
                Thêm địa chỉ nhận hàng
              </a>
            </div>
          )}
          <div className="accessories-item__content__action">
            <Button
              className="confirm"
              disabled={
                data?.quantity <= 0 ||
                pointHas < data?.price ||
                !qualifiedLevel ||
                data?.isOwned
              }
              onClick={() => handleOnClickBuy(data?.id)}
            >
              {t(renderText())}
            </Button>
            <Button className="cancel" onClick={onCancel}>
              {t("cancel")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AccessoriesItem;
